export const socialLinks = {
  github: "https://github.com/runesatsdev",
  discord: "https://discordapp.com/users/396045977083183104",
  linkedin: "https://www.linkedin.com/in/david-k-9aaa67393/",
  twitter: "https://x.com/runesatsdev",
  telegram: "https://t.me/runesats",
  whatsapp: "https://wa.me/18497200344",
  twitterfollow: "https://twitter.com/intent/follow?screen_name=runesatsdev"
};
